import { TypographyXS } from "@/components/typography/XS";
import { TypographyBase } from "../typography/Base";
import { TypographySM } from "../typography/SM";

interface Props {
  title: string;
  children: React.ReactNode;
  description?: React.ReactNode;
}

const SettingsSection = ({ title, description, children }: Props) => {
  return (
    <div className="px-8 py-6 bg-brand-gray-50 dark:bg-brand-gray-900 rounded">
      <TypographyBase className="text-brand-gray-900 dark:text-brand-gray-50 inline-flex">
        {title}
      </TypographyBase>
      {description && (
        <TypographySM className="mt-1 text-brand-gray-700 dark:text-brand-gray-200">
          {description}
        </TypographySM>
      )}
      <div className="my-6" />
      <div className="flex flex-col gap-6">{children}</div>
    </div>
  );
};

const SettingsItem = ({ title, description, children }: Props) => {
  return (
    <div className="w-full items-center grid grid-cols-[1fr_2fr_2fr] gap-10">
      <TypographySM className="text-brand-gray-800 dark:text-brand-gray-100 inline-flex">
        {title}
      </TypographySM>
      {children}
      {description && (
        <TypographyXS className="text-brand-gray-800 dark:text-brand-gray-100 font-light">
          {description}
        </TypographyXS>
      )}
    </div>
  );
};

const Settings = {
  Section: SettingsSection,
  Item: SettingsItem
};

export { Settings };
